/*
 * Masculino Latino: product page behaviour (ml-main-product).
 * Pack selector, colour swatches, size chips, add to cart through MLCart (/cart/add.js),
 * URL parameters ?pack= ?size= ?variant=, gallery counter and zoom, size guide, sticky bar.
 */
(function () {
  if (customElements.get('ml-product')) return;
  const T = window.mlStrings || {};
  const rupees = (n) => (window.MLPack ? window.MLPack.formatRupees(n) : '₹' + n);

  class MLProduct extends HTMLElement {
    connectedCallback() {
      const json = this.querySelector('[data-ml-product-json]');
      this.data = { variants: [], sizeIndex: -1, colourIndex: -1 };
      try {
        if (json) this.data = JSON.parse(json.textContent);
      } catch (e) {
        console.warn('ml-product: product data could not be read', e);
      }
      this.eligible = this.dataset.eligible === 'true';
      this.form = this.querySelector('form[data-type="add-to-cart-form"]');
      this.idInput = this.querySelector('[data-ml-variant-input]');
      this.qtyInput = this.querySelector('[data-ml-qty-input]');
      this.atc = this.querySelector('[data-ml-atc]');
      this.sizesEl = this.querySelector('[data-ml-sizes]');
      this.errorEl = this.querySelector('[data-ml-size-error]');
      this.sticky = this.querySelector('[data-ml-sticky]');

      const params = new URLSearchParams(window.location.search);
      const pressedColour = this.querySelector('[data-ml-colour][aria-pressed="true"]');
      const first = this.currentVariantFromInput();
      this.colour = pressedColour ? pressedColour.dataset.mlColour : first && this.data.colourIndex >= 0 ? first.options[this.data.colourIndex] : null;
      this.size = this.data.preselectedSize || null;

      const sizeParam = params.get('size');
      if (sizeParam && this.data.sizeIndex >= 0) {
        const match = this.data.variants.find(
          (v) => String(v.options[this.data.sizeIndex]).toLowerCase() === sizeParam.toLowerCase() && this.colourMatches(v) && v.available
        );
        if (match) this.size = match.options[this.data.sizeIndex];
      }
      const packParam = params.get('pack');
      if (packParam) {
        const radio = Array.from(this.querySelectorAll('[data-ml-pack] input[type="radio"]')).find(
          (r) => (r.dataset.name || '').toLowerCase() === packParam.toLowerCase()
        );
        if (radio) radio.checked = true;
      }

      this.bind();
      this.update({ fromInit: true });
      this.setupGallery();
      this.setupSticky();
    }

    currentVariantFromInput() {
      const id = Number(this.idInput && this.idInput.value);
      return this.data.variants.find((v) => v.id === id) || this.data.variants[0];
    }

    colourMatches(v) {
      return this.data.colourIndex < 0 || !this.colour || v.options[this.data.colourIndex] === this.colour;
    }

    tier() {
      const r = this.querySelector('[data-ml-pack] input[type="radio"]:checked');
      if (!r || !this.eligible) return null;
      return { index: r.value, name: r.dataset.name, min: Number(r.dataset.min) || 1, off: Number(r.dataset.off) || 0 };
    }

    variant() {
      const vs = this.data.variants;
      const si = this.data.sizeIndex;
      if (si >= 0 && this.size) {
        return vs.find((v) => this.colourMatches(v) && v.options[si] === this.size) || null;
      }
      return vs.find((v) => this.colourMatches(v) && v.available) || vs.find((v) => this.colourMatches(v)) || vs[0];
    }

    needsSize() {
      return this.data.sizeIndex >= 0 && !this.size;
    }

    bind() {
      this.addEventListener('click', (e) => {
        const sw = e.target.closest('[data-ml-colour]');
        if (sw) {
          this.colour = sw.dataset.mlColour;
          const still = this.data.variants.find((v) => this.colourMatches(v) && v.options[this.data.sizeIndex] === this.size && v.available);
          if (!still) this.size = null;
          this.update({ colourChanged: true });
          return;
        }
        const chip = e.target.closest('[data-ml-size]');
        if (chip) {
          if (chip.classList.contains('is-soldout')) return;
          this.size = chip.dataset.mlSize;
          this.clearError();
          this.update();
          return;
        }
        if (e.target.closest('[data-ml-open-guide]')) {
          const g = this.querySelector('[data-ml-guide]');
          if (g && g.showModal) g.showModal();
          return;
        }
        if (e.target.closest('[data-ml-guide-close]')) {
          this.querySelector('[data-ml-guide]').close();
          return;
        }
        const unit = e.target.closest('[data-ml-unit]');
        if (unit) {
          const table = this.querySelector('.ml-guide__table');
          if (table) table.dataset.unit = unit.dataset.mlUnit;
          this.querySelectorAll('[data-ml-unit]').forEach((b) => b.setAttribute('aria-pressed', String(b === unit)));
          return;
        }
        const zoom = e.target.closest('[data-ml-zoom]');
        if (zoom) {
          const d = this.querySelector('[data-ml-zoom-dialog]');
          d.querySelector('[data-ml-zoom-img]').src = zoom.dataset.mlZoom;
          d.showModal();
          return;
        }
        if (e.target.closest('[data-ml-zoom-close]')) {
          this.querySelector('[data-ml-zoom-dialog]').close();
          return;
        }
        if (e.target.closest('[data-ml-sticky-atc]')) {
          if (this.needsSize()) this.showSizeError(true);
          else this.addToCart('sticky');
        }
      });

      this.addEventListener('change', (e) => {
        if (e.target.matches('[data-ml-pack] input[type="radio"]')) this.update();
      });

      if (this.form) {
        this.form.addEventListener('submit', (e) => {
          e.preventDefault();
          if (this.needsSize()) {
            this.showSizeError(false);
            return;
          }
          this.addToCart('pdp');
        });
      }

      const buyNow = this.querySelector('[data-ml-buy-now]');
      if (buyNow) {
        buyNow.addEventListener(
          'click',
          (e) => {
            if (this.needsSize()) {
              e.preventDefault();
              e.stopPropagation();
              this.showSizeError(false);
            }
          },
          true
        );
      }
    }

    clearError() {
      if (this.sizesEl) this.sizesEl.classList.remove('has-error');
      if (this.errorEl) this.errorEl.hidden = true;
    }

    showSizeError(scroll) {
      if (!this.sizesEl) return;
      this.sizesEl.classList.add('has-error');
      this.sizesEl.classList.remove('ml-shake');
      void this.sizesEl.offsetWidth;
      this.sizesEl.classList.add('ml-shake');
      if (this.errorEl) this.errorEl.hidden = false;
      if (scroll) {
        this.sizesEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
        const firstChip = this.sizesEl.querySelector('[data-ml-size]:not(.is-soldout)');
        if (firstChip) setTimeout(() => firstChip.focus({ preventScroll: true }), 400);
      }
    }

    update(opts) {
      opts = opts || {};
      const d = this.data;
      const v = this.variant();
      const t = this.tier();
      const qty = t ? t.min : 1;
      const off = t ? t.off : 0;

      // Colour swatches and name
      this.querySelectorAll('[data-ml-colour]').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.mlColour === this.colour)));
      const cn = this.querySelector('[data-ml-colour-name]');
      if (cn && this.colour) cn.textContent = this.colour;

      // Size chips: availability for the selected colour
      this.querySelectorAll('[data-ml-size]').forEach((chip) => {
        const size = chip.dataset.mlSize;
        const avail = d.variants.some((x) => this.colourMatches(x) && x.options[d.sizeIndex] === size && x.available);
        chip.classList.toggle('is-soldout', !avail);
        if (!avail) {
          chip.setAttribute('aria-disabled', 'true');
          chip.setAttribute('aria-label', size + ', ' + (T.soldOut || 'sold out').toLowerCase());
        } else {
          chip.removeAttribute('aria-disabled');
          chip.removeAttribute('aria-label');
        }
        chip.setAttribute('aria-pressed', String(size === this.size && avail));
      });

      if (!v) return;
      if (this.idInput) this.idInput.value = v.id;
      if (this.qtyInput) this.qtyInput.value = qty;

      // Price
      const price = v.price / 100;
      const main = this.querySelector('[data-ml-price-main]');
      const cmp = this.querySelector('[data-ml-price-compare]');
      const save = this.querySelector('[data-ml-price-save]');
      const note = this.querySelector('[data-ml-price-note]');
      let mainVal = price;
      let cmpVal = 0;
      let saveVal = 0;
      if (t && qty > 1) {
        mainVal = (price - off) * qty;
        if (off > 0) {
          cmpVal = price * qty;
          saveVal = off * qty;
        }
        if (note)
          note.textContent = (T.packOf || '[name] pack of [count], [each] a piece.')
            .replace('[name]', t.name)
            .replace('[count]', qty)
            .replace('[each]', rupees(price - off));
      } else {
        if (v.compare > v.price) {
          cmpVal = v.compare / 100;
          saveVal = cmpVal - price;
        }
        if (note) note.textContent = T.perPiece || '';
      }
      if (main) main.textContent = rupees(mainVal);
      if (cmp) {
        cmp.hidden = !cmpVal;
        cmp.textContent = cmpVal ? rupees(cmpVal) : '';
      }
      if (save) {
        save.hidden = !saveVal;
        save.textContent = saveVal ? (T.save || 'Save [amount]').replace('[amount]', rupees(saveVal)) : '';
        if (saveVal && !opts.fromInit) {
          save.classList.remove('ml-pop');
          void save.offsetWidth;
          save.classList.add('ml-pop');
        }
      }

      // Pack cards follow the variant price
      this.querySelectorAll('[data-ml-tier]').forEach((card) => {
        const r = card.querySelector('input');
        card.classList.toggle('is-selected', r.checked);
        const min = Number(r.dataset.min) || 1;
        const o = Number(r.dataset.off) || 0;
        const each = price - o;
        const pcs = card.querySelector('[data-ml-pack-pcs]');
        if (pcs)
          pcs.textContent =
            min === 1 ? T.piece || '1 piece' : (T.pieces || '[count] pieces').replace('[count]', min) + ', ' + (T.each || '[amount] each').replace('[amount]', rupees(each));
        const tot = card.querySelector('[data-ml-pack-total]');
        if (tot) tot.textContent = rupees(each * min);
        const sv = card.querySelector('[data-ml-pack-save]');
        if (sv) sv.textContent = (T.save || 'Save [amount]').replace('[amount]', rupees(o * min));
      });

      // Button
      const label = this.querySelector('[data-ml-atc-label]');
      const available = this.needsSize() ? true : v.available;
      if (this.atc) this.atc.toggleAttribute('aria-disabled', !available);
      if (label && !this.atc.classList.contains('ml-btn--added')) label.textContent = available ? T.addToCart : T.soldOut;

      // URL and gallery
      if (!opts.fromInit && (this.size || opts.colourChanged) && window.history.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
      if (opts.colourChanged && v.media) this.scrollToMedia(v.media);

      this.updateSticky(v, t, mainVal);
    }

    async addToCart(source) {
      const v = this.variant();
      if (!v || !v.available) return;
      const t = this.tier();
      const qty = t ? t.min : 1;
      const btns = [this.atc, this.querySelector('[data-ml-sticky-atc]')].filter(Boolean);
      btns.forEach((b) => b.setAttribute('aria-busy', 'true'));
      try {
        await window.MLCart.add([{ id: v.id, quantity: qty }], source);
        this.flashAdded();
      } catch (err) {
        if (this.errorEl) {
          this.errorEl.hidden = false;
          this.errorEl.lastChild.textContent = err.message;
        }
      } finally {
        btns.forEach((b) => b.removeAttribute('aria-busy'));
      }
    }

    flashAdded() {
      const label = this.querySelector('[data-ml-atc-label]');
      const tick = this.querySelector('.ml-pdp__atc-tick');
      if (!this.atc || !label) return;
      this.atc.classList.add('ml-btn--added');
      label.textContent = T.added || 'Added';
      if (tick) {
        tick.hidden = false;
        tick.classList.add('ml-pop');
      }
      clearTimeout(this._added);
      this._added = setTimeout(() => {
        this.atc.classList.remove('ml-btn--added');
        label.textContent = T.addToCart || 'Add to cart';
        if (tick) tick.hidden = true;
      }, 1500);
    }

    /* Gallery */
    setupGallery() {
      this.gallery = this.querySelector('[data-ml-gallery]');
      const counter = this.querySelector('[data-ml-counter]');
      if (!this.gallery || !counter) return;
      const total = this.gallery.children.length;
      this.gallery.addEventListener(
        'scroll',
        () => {
          const w = this.gallery.clientWidth || 1;
          const i = Math.min(total, Math.round(this.gallery.scrollLeft / w) + 1);
          counter.textContent = i + '/' + total;
        },
        { passive: true }
      );
    }

    scrollToMedia(mediaId) {
      const slide = this.querySelector('[data-media-id="' + mediaId + '"]');
      if (!slide || !this.gallery) return;
      if (this.gallery.scrollWidth > this.gallery.clientWidth + 4) {
        this.gallery.scrollTo({ left: slide.offsetLeft - this.gallery.offsetLeft, behavior: 'smooth' });
      }
    }

    /* Sticky bar */
    setupSticky() {
      if (!this.sticky || !this.atc) return;
      const footer = document.querySelector('.ml-footer');
      const btn = this.sticky.querySelector('[data-ml-sticky-atc]');
      let ticking = false;
      const check = () => {
        ticking = false;
        const past = this.atc.getBoundingClientRect().bottom < 0;
        const atFooter = footer ? footer.getBoundingClientRect().top < window.innerHeight : false;
        const show = past && !atFooter;
        if (show === this.sticky.classList.contains('is-visible')) return;
        this.sticky.classList.toggle('is-visible', show);
        this.sticky.setAttribute('aria-hidden', String(!show));
        if (btn) btn.tabIndex = show ? 0 : -1;
      };
      window.addEventListener(
        'scroll',
        () => {
          if (!ticking) {
            ticking = true;
            requestAnimationFrame(check);
          }
        },
        { passive: true }
      );
      window.addEventListener('resize', check);
      check();
    }

    updateSticky(v, t, total) {
      if (!this.sticky) return;
      const parts = [];
      if (t) parts.push(t.name);
      if (this.colour) parts.push(this.colour);
      if (this.size) parts.push(String(this.size).toUpperCase());
      const s = this.sticky.querySelector('[data-ml-sticky-summary]');
      if (s && parts.length) s.textContent = parts.join(', ');
      const p = this.sticky.querySelector('[data-ml-sticky-price]');
      if (p) p.textContent = rupees(total);
      const img = this.sticky.querySelector('[data-ml-sticky-img]');
      if (img && v.image) img.src = v.image;
      const b = this.sticky.querySelector('[data-ml-sticky-atc]');
      if (b) b.textContent = this.needsSize() ? T.chooseSize : T.addToCart;
    }
  }

  customElements.define('ml-product', MLProduct);
})();
